<template>
  <div class="main">
    <div class="row infos">
      <div class="col-xl-4 col-lg-12">
        <div class="blc-dados">
          <img src="/img/icon-lines.png" alt="icone porto" />
          <p>List Line-up</p>
        </div>
      </div>
    </div>
    <div>
      <lineup-filters 
        v-model="search"
        :loading="loadingPortos"
        :statusOptions="Service.status()"
        :clientTypes="Service.clientTypes()"
        :options="{ portos: portosFiltro, cargas, afretadores, lineupPortos, recebedores, navios }"
        @search="listarPortos(true)"
        @clear="cleanFiltros"
        @exportAll="exportAll"
        @new="openCreateForm({ id: null })"
      />

      <div class="bg-lineups" v-if="!loadingPortos && portos.length === 0">
        <div class="blc-descracao text-center py-4">
          <div class="col-12">
            <h4 class="mb-0">No vessel found</h4>
          </div>
        </div>
      </div>

      <porto-container
        v-for="porto in portos"
        :key="porto.id"
        :porto="porto"
        :search="search"
        :hasPortFilter="search.porto_id && search.porto_id.length > 0"
        :extraData="{ 
          carga: cargaSelecionada,
          cargas: cargas.reduce((a, b) => a.concat(b.cargas), []),
          navios: navios,
          carga_tipo_id: search.carga_tipo_id,
          afretadores: afretadores,
          lineupPortos: lineupPortos,
          agencias: agencias,
          userPortosIds: userPortosIds,
          recebedores: recebedores,
        }"
        @openModal="openCreateForm"
        @newLineup="openCreateForm"
        @exportTerminal="exportLineups"
        @exportPorts="exportPorts"
        @sendProspect="sendProspect"
      />

      <div id="porto-sentinel" style="height: 50px; text-align: center;">
        <i v-if="loadingPortos" class="fa fa-spinner fa-spin fa-2x"></i>
      </div>
    </div>
    
    <excluir-modal
      :show="$root.modal.excluir.isOpen"
      :mensagem="$root.modal.excluir.mensagem"
      :model="$root.modal.excluir.model"
      :service="$root.modal.excluir.service"
      @close="handleExcluir"
    ></excluir-modal>

     <modal :show="modal.export.show" @close="modal.export.show = false" modalClasses="modal-md">
      <template v-slot:header>
        <span style="color: transparent">Exportar lineup</span>
      </template>
      <template>
        <modal-export-lineups
          v-if="modal.export.show"
          :type="modal.export.type"
          :params="modal.export.params"
          :portos="portos"
          @close="modal.export.show = false"
        />
      </template>
    </modal>
    <modal :show="modal.form.show" @close="modal.form.show = false" modalClasses="modal-xl">
      <template v-slot:header>
        <span style="color: transparent">Lineup</span>
      </template>
      <template>
        <lineup-form
          v-if="modal.form.show"
          :id="modal.form.id"
          :isModal="1"
          :premodel="modal.form.premodel"
          :withParams="true"
          :params="{
            navios: navios,
            portos: portosFiltro,
            agencias: agencias,
            cargasTipos: cargas,
            lineupPortos: lineupPortos,
            afretadores: afretadores,
            recebedores: recebedores,
          }"
          @saved="handleLineupSaved"
        />
      </template>
    </modal>
  </div>
</template>

<script>
  import Service from "@/services/Lineups";
  import PortosService from "@/services/Portos";
  import CargasTiposService from "@/services/CargasTipos";
  import PortoContainer from "./Components/PortoContainer.vue";
  import LineupFilters from "./Components/LineupFilters.vue";
  import FormLineup from "./Form.vue";
  import ModalExportLineups from "@/components/Modal/ModalExportLineups";
  

  export default {
    components: {
      "porto-container": PortoContainer,
      "lineup-form": FormLineup,
      "modal-export-lineups": ModalExportLineups,
      "lineup-filters": LineupFilters,
    },
    data() {
      return {
        Service,
        cargaSelecionada: {},
        portoSelecionado: {},
        isReady: false,
        loadingParameters: false,
        cargas: [
          {
            id: 1,
            name: "AGRI COMMODITIES",
            atualizado_data: null,
            atualizado_id: null,
            created_at: "2023-07-10T15:33:09.000000Z",
            updated_at: "2023-07-11T16:00:56.000000Z",
            cargas: [],
            deleted_at: null,
            atualizador: null,
          },
          {
            id: 3,
            name: "CHEMICAL",
            atualizado_data: null,
            atualizado_id: null,
            cargas: [],
            created_at: "2023-07-19T13:47:34.000000Z",
            updated_at: "2023-07-19T13:47:34.000000Z",
            deleted_at: null,
            atualizador: null,
          },
          {
            id: 2,
            name: "FERTILIZER",
            atualizado_data: null,
            atualizado_id: null,
            cargas: [],
            created_at: "2023-07-10T15:33:09.000000Z",
            updated_at: "2023-07-10T15:33:09.000000Z",
            deleted_at: null,
            atualizador: null,
          },
          {
            id: 5,
            name: "GENERAL CARGO",
            atualizado_data: null,
            cargas: [],
            atualizado_id: null,
            created_at: "2023-09-14T15:19:46.000000Z",
            updated_at: "2023-09-14T15:21:37.000000Z",
            deleted_at: null,
            atualizador: null,
          },
          {
            id: 6,
            name: "SPODUMENE",
            atualizado_data: null,
            atualizado_id: null,
            cargas: [],
            created_at: "2023-09-24T10:56:39.000000Z",
            updated_at: "2023-09-24T10:56:39.000000Z",
            deleted_at: null,
            atualizador: null,
          },
        ],
        navios: [],
        afretadores: [],
        terminais: [],
        agencias: [],
        bercos: [],
        terminal: {},
        lineupPortos: [],
        recebedores: [],
        trabalhadores: [],
        loading: false,
        pagination: {
          nextCursor: null,
          prevCursor: null,
          nextPageUrl: null,
          prevPageUrl: null
        },
        modal: {
          form: {
            show: false,
            id: null,
            premodel: {},
          },
          export: {
            show: false,
            type: "porto",
            params: {},
          },
        },
        list: [],
        portos: [],
        portosPagination: { nextCursor: null },
        loadingPortos: false,
        observer: null,
        portosFiltro: [],
        search: {
          carga_tipo_id: null,
          porto_id: [],
          status: [
            "Loading",
            "Discharging",
            "Waiting",
            "Expected",
            "POB hh:mm lt",
          ],
          recebedor_id: [],
          embarcadores: [],
          agencia_id: [],
          navio_id: [],
          afretador_id: [],
          periodo_inicio: null,
          periodo_fim: null,
          destination_port: null,
          client_type: [],
        },
        defaultSearch: {},
        orderBy: {
          campo: "name",
          ordem: "asc",
        },
        userPortosIds: [],
      };
    },
    created() {
      this.defaultSearch = { ...this.search };
    },
    watch: {
      search: {
        deep: true,
        handler() {
          if (this.isReady) {
            this.listarPortos(true);
          }
        },
      },
    },
    mounted() {
      this.initAll();
      this.initInfiniteScroll();
    },
    methods: {
      async initAll() {
        this.loadingParameters = true;
        try {
          await this.listParameters();
          this.$nextTick(() => {
            this.isReady = true;
            this.listarPortos(true);
            this.listarCargasTipos();
          });
        } finally {
          this.loadingParameters = false;
        }
      },
      initInfiniteScroll() {
        const sentinel = document.getElementById("porto-sentinel");
        if (!sentinel) return;

        this.observer = new IntersectionObserver((entries) => {
          if (entries[0].isIntersecting && this.portosPagination.nextCursor && !this.loadingPortos) {
            this.listarPortos();
          }
        }, { threshold: 0.1 });
        this.observer.observe(sentinel);
      },
      listParameters() {
        Service.parametros({
          navios: true,
          agencias: true,
          lineups_portos: true,
          afretadores: true,
          trabalhadores: true,
          portos: true,
          recebedores: true,
        }).then((response) => {
          this.navios = response.data.navios;
          this.lineupPortos = response.data.lineups_portos;
          this.agencias = response.data.agencias;
          this.afretadores = response.data.afretadores;
          this.trabalhadores = response.data.trabalhadores;
          this.recebedores = response.data.recebedores;
          this.userPortosIds = response.data.portos.map((p) => p.id);
          this.portosFiltro = response.data.portos;
        });
      },
      listarPortos(clear = false) {
        this.loadingPortos = true;
        if (clear) { 
          this.portos = []; 
          this.portosPagination.nextCursor = null; 
        }
        PortosService.get({
          id: this.search.porto_id?.length ? this.search.porto_id : null,
          cursor: this.portosPagination.nextCursor,
          campo: "ordem",
          ordem: "asc",
          limit: 3,
          carga_tipo_id: this.search.carga_tipo_id,
          navio_id: this.search.navio_id?.length ? this.search.navio_id : null,
          status: this.search.navio_id?.length && this.search.status?.length ? this.search.status : null,
          periodo_inicio: this.search.navio_id?.length ? this.search.periodo_inicio : null,
          periodo_fim: this.search.navio_id?.length ? this.search.periodo_fim : null,
          type: this.search.navio_id?.length ? this.search.type : null,
          with: ["terminais.bercos", "weathersAtuais"],
        }).then(res => {
          const NovosPortos = res.data.data ? res.data.data : res.data;
          this.portos = clear ? NovosPortos : [...this.portos, ...NovosPortos];
          this.portosPagination.nextCursor = res.data.next_cursor || null;
        }).finally(() => { 
          this.loadingPortos = false; 
        });
      },
      openExportModal(type, params) {
        this.modal.export.show = true;
        this.modal.export.type = type;
        this.modal.export.params = params;
      },
      openCreateForm(lineup) {
        this.modal.form.show = true;
        this.modal.form.id = lineup.id;
        this.modal.form.premodel = lineup;
      },
      handleExcluir(updated) {
        this.$root.modal.excluir.isOpen = false;
        if (updated) this.listar(true);
      },
      handleLineupSaved() {
        this.modal.form.show = false;
        this.listarPortos(true);
      },
      sendProspect(lineup) {
        Service.sendProspect({lineup_id: lineup.id, navio_id: lineup.navio_id})
        .then((response) => {
          this.$notify({
            type: "success",
            message: response.data.message ?? "Prospects requested successfully! You will receive an email shortly.",
          });
        })
        .catch((err) => {
          this.$notify({
            type: "danger",
            message: err?.response?.data?.message ?? "Failed to send prospect request. Please try again.",
          });
        })
        .finally(() => {
          this.loading = false;
        });
      },
      setCarga(carga) {
        if (carga) {
          this.cargaSelecionada = carga;
          this.search.carga_tipo_id = carga?.id ? carga.id : null;
        } else {
          this.cargaSelecionada = {};
        }
      },
      setPortoSelecionado(porto) {
        if (porto && porto.id) {
          this.portoSelecionado = porto;
          this.search.porto_id = [porto.id];
        } else {
          this.portoSelecionado = {};
          this.search.porto_id = [];
        }
      },
      cargaAtualizada(carga, atualizar) {
        this.loading = true;
        CargasTiposService.atualizar(carga, atualizar).then((response) => {
          carga.atualizado_data = response.data.atualizado_data;
          carga.atualizador = response.data.atualizador;
          this.$notify({
            type: "success",

            message: "Updated successfully!",
            horizontalAlign: "center",
          });
          this.loading = false;
        });
      },

      portoAtualizado(porto, carga, atualizar) {
        this.loading = true;
        PortosService.atualizar(porto, carga, atualizar).then((response) => {
          porto.carga_atualizada = response.data;
          this.$notify({
            type: "success",
            message: "Updated successfully!",
            horizontalAlign: "center",
          });
          this.loading = false;
        });
      },
      listarCargasTipos() {
        this.loading = true;
        this.cargas = [];
        CargasTiposService.get({
          with: ["cargas", "atualizador"],
          ...this.search,
        }).then((response) => {
          this.cargas = response.data;
          this.loading = false;
        });
      },
      cleanFiltros() {
        this.search = JSON.parse(JSON.stringify(this.defaultSearch));
        this.listarPortos(true);
      },
      exportLineups(terminalId) {
        this.openExportModal("terminal", { ...this.search, terminal_id: terminalId });
      },
      exportPorts(portoId) {
        this.openExportModal("porto", { ...this.search, porto_id: portoId });
      },
      exportAll() {
        this.openExportModal("all", { ...this.search });
      },
    },
  };
</script>
<style scoped>
  .cursor-pointer {
    cursor: pointer;
  }
  .form-group {
    margin-bottom: 0.5rem;
  }
  .nav-tabs .nav-link.active,
  .nav-tabs .nav-item.show .nav-link {
    color: #525f7f;
    background-color: #f8f9fe;
    border-color: #123e76 #123e76 #fff;
  }
  .nav-tabs {
    border-bottom: 1px solid #123e76;
  }
  #ports-tabs li.nav-item a.nav-link,
  #comms-tabs li.nav-item a.nav-link {
    cursor: pointer;
  }
  .status-table tr td {
    border: solid 1px black;
  }
  #terminal-fields div p {
    height: 80px;
  }
  /*****************************************
                  NOVOS
******************************************/

  .descracao_mobile {
    display: none;
  }

  @media (max-width: 991px) {
    .descracao_mobile {
      display: block !important;
    }
    .blc-descracao-desktop {
      display: none !important;
    }
    .blc-descracao {
      padding: 0;
    }
    .result_top {
      background: #414141;
      text-align: center;
      text-transform: uppercase;
      color: #fff;
      width: 95px;
      font-family: var(--font-oswald);
      font-weight: var(--font-extralight);
      font-size: 14px;
      height: 50px;
      border-radius: 5px;
      display: -webkit-box;
      display: -ms-flexbox;
      justify-content: center;
      margin-top: 7px;
      margin-right: 5px;
      align-items: center;
    }
    .result {
      background: #ebebeb;
      text-align: center;
      text-transform: uppercase;
      color: #414141;
      width: 95px;
      font-family: var(--font-oswald);
      font-weight: var(--font-extralight);
      font-size: 14px;
      height: 50px;
      border-radius: 5px;
      display: -webkit-box;
      display: -ms-flexbox;
      justify-content: center;
      margin-top: 7px;
    }
  }
  .flex {
    display: flex;
  }
  .justify-between {
    justify-content: space-between;
  }
  .items-center {
    align-items: center;
  }
  .mt-1 {
    margin-top: 1rem;
  }

  #conteudo .main .blc-dados img {
    background: #59b528;
  }
</style>
